import Cookies from 'js-cookie';

export default class GenericCookieStrategy {

  constructor(cookieName) {
    this.cookieName = cookieName;
    this.cookieApi = Cookies;
  }

  getToken() {
    return this.cookieApi.get(this.cookieName);
  }

  setToken(token) {
    this.cookieApi.set(this.cookieName, token);
  }

  removeToken() {
    this.cookieApi.remove(this.cookieName);
  }

  setCookieApi(cookieApi) {
    this.cookieApi = cookieApi;
  }
}



// WEBPACK FOOTER //
// ./src/auth/tokenStrategies/genericCookieStrategy.js